
import { Actions } from '../../util/Constants';

module.exports = app => ({
  card: {
    onAddCard() {
      app.channel.trigger(Actions.tealium.linkTag, {
        account_action: 'add macys card start',
        event_name: 'edit account',
      });
    },
  },
});
